import { createLocalStorageStateHook } from 'use-local-storage-state';

export const DEFAULT_MEASUREMENT_DURATION = 60;
export const MIN_MEASUREMENT_DURATION = 20;
export const MAX_MEASUREMENT_DURATION = 180;

// Default license key for demo purposes
export const DEFAULT_LICENSE_KEY = '6DE0A1-0E3FFF-41838F-D08990-F306F5-31CDB2';

export const useLicenseKey = createLocalStorageStateHook('licenseKey', DEFAULT_LICENSE_KEY);
export const useProductId = createLocalStorageStateHook('productId', null);
export const useMeasurementDuration = createLocalStorageStateHook(
  'measurementDuration',
  DEFAULT_MEASUREMENT_DURATION,
);
